<template>
    <div id="edit_core_waybill" class="ui segment">
        <CoreWaybill
            v-if="is_initialized"
            :core_waybill="core_waybill"
            :template="'detail'"
            :is_force_print="true"
            :is_auto_print="false"
            :is_can_update="true"
            :is_can_print_label="true"
            :is_show_change_template_btns="false"
            :cant_update_field_names="['operation_number']"
            :detail="{
                is_show_blood_related: true,
                is_show_receipt_file: true,
                is_show_partition: true,
                is_show_statuses: true,
            }"
        >
        </CoreWaybill>
        <Comments :commentable_type="'CoreWaybill'" :commentable_identity="core_waybill.identity" :scope="'provider'"></Comments>
    </div>
</template>

<script>
import CoreWaybill from '@toolbox/core_waybill/main.vue'
import Comments from "@toolbox/bulletin_board/comments.vue"

export default {
    name: "EditCoreWaybill",
    components: {
        CoreWaybill,
        Comments,
    },
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            core_waybill: {},
            errors: [],
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "edit_core_waybill") {
                this.init()
            }
        },
    },
    computed: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.core_waybill = {}
                this.errors = []
                resolve()
            })
            await this.fetch_core_waybill()
            await new Promise(resolve => {
                this.$store.state.provider.core_waybills_module.current_core_waybill = this.core_waybill
                this.is_initialized = true
            })
        },
        fetch_core_waybill() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill).parse(
                {
                    "core_waybill_identity": this.$route.params.identity
                }
            )
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.core_waybill = response.data.core_waybill
                })
                .catch(error => {
                    // this.$noty.error('取得訂單資訊失敗')
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' + error
                        })
                    )
                    return Promise.reject(error)
                })
        },
    },
}
</script>

<style scoped lang="scss">
    @import "../../.assets/stylesheets/form.scss";
</style>
